import type { VisibilityTag } from '@/layout/featureTypes'
import { createGlobalState } from '@vueuse/core'
import { computed, reactive } from 'vue'

export interface RenderedSectionEntry {
  /** Page/stage this rendered instance belongs to. */
  tag: VisibilityTag
  /** Raw hash identifier (no leading `#`), e.g. `"general"`. */
  hash: string
  /** Display label for the sidebar. */
  label: string
  /** Position order for stable sidebar ordering. */
  order: number
}

function entryKey(tag: VisibilityTag, hash: string): string {
  return `${String(tag)}\u0000${hash}`
}

export const useRenderedSections = createGlobalState(() => {
  const map = reactive(new Map<string, RenderedSectionEntry>())

  function register(entry: RenderedSectionEntry): void {
    map.set(entryKey(entry.tag, entry.hash), entry)
  }

  function unregister(tag: VisibilityTag, hash: string): void {
    map.delete(entryKey(tag, hash))
  }

  const sections = computed<RenderedSectionEntry[]>(() =>
    [...map.values()].sort((a, b) => a.order - b.order),
  )

  return { register, unregister, sections }
})
